import styled from "styled-components";

import { colors } from "./colors";

export const RadioButton = styled.input.attrs({ type: "radio" })`
    appearance: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.whiteDuplicate};
    border: 1px solid ${colors.radioButtonBorder};
    border-radius: 50%;
    width: 1.0625rem;
    height: 1.0625rem;
    outline: none;
    margin: 0;

    &:checked::before {
        content: "";
        background-color: ${colors.darkSkyBlue};
        height: 0.5625rem;
        width: 0.5625rem;
        border-radius: 50%;
    }

    &:focus {
        box-shadow: 0 0 0 3px ${colors.aqua};
    }
`;
